import type { Operator } from '@@partner:types:app'
import type { GQL_ID } from '@@partner:types:graphql'

import { gql, useMutation } from '@apollo/client'
import { SHORTCUT_EMPLOYEE_FIELDS } from '@@partner:graphql/shortcuts'

export interface OperatorInfoInput {
  id?: GQL_ID
  first_name: string
  last_name: string
  status: number
  phone: string
  email: string
  password?: string
}

export interface SaveOperator {
  operator: Operator
}

export interface SaveOperatorVariables {
  operatorInfo: OperatorInfoInput
  upsert: boolean
}

export const GQL_MUTATION_SAVE_OPERATOR = gql`
  mutation($operatorInfo: OperatorInfoInput, $upsert: Boolean) {
    operator: updateOperator(newData: $operatorInfo, upsert: $upsert) {
      ${SHORTCUT_EMPLOYEE_FIELDS}
      email
    }
  }
`

export const useMutateSaveOperator = () => {
  return useMutation<SaveOperator, SaveOperatorVariables>(
    GQL_MUTATION_SAVE_OPERATOR
  )
}
